import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ReactComponent as Export } from '../../../webcommon/common/Icons/Export.svg';
import styles from '../GridHeaderButton.module.scss';
import * as actions from './actions';

const DownloadCrif = (props) => {
    const { dateFrom, csaSelected, downloadCrif } = props;
    const onClick = useCallback(() => {
        if (dateFrom && csaSelected) {
            downloadCrif(dateFrom, csaSelected);
        }
    }, [dateFrom, csaSelected, downloadCrif]);

    return (
        <button
            className={ styles.gridHeaderButton }
            type="button"
            onClick={ onClick }
        >
            Download CRIF <Export />
        </button>
    );
};

DownloadCrif.propTypes = {
    csaSelected: PropTypes.string,
    dateFrom: PropTypes.string,
    downloadCrif: PropTypes.func.isRequired
};

DownloadCrif.defaultProps = {
    csaSelected: '',
    dateFrom: ''
};

const mapDispatchToProps = dispatch => ({
    downloadCrif: (date, csa) => dispatch(actions.downloadCrifRequested(date, csa))
});

export const DownloadCrifUnconnected = DownloadCrif;

export default connect(null, mapDispatchToProps)(DownloadCrif);
